var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-group" }, [
      _c("div", { staticClass: "tab active ani-fast" }, [
        _c("div", { staticClass: "tab-name f-h3" }, [_vm._v("Projects")]),
        _c("div", { staticClass: "border pill" })
      ]),
      _c("div", { staticClass: "tab pointer ani-fast" }, [
        _c("div", { staticClass: "tab-name f-h3" }, [_vm._v("Sites")]),
        _c("div", { staticClass: "border pill" })
      ]),
      _c("div", { staticClass: "tab pointer ani-fast" }, [
        _c("div", { staticClass: "tab-name f-h3" }, [_vm._v("Sites")]),
        _c("div", { staticClass: "border pill" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }